"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MirEngBig = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MirEngBig = function MirEngBig(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M47.492 13.806h-13.79v7.172h4.372V16.94h1.845l2.479 4.04h4.97l-2.92-4.378c1.404-.501 2.516-1.52 3.044-2.795z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.423 7.314c.019.366.072.723.153 1.068.02.077.036.155.059.23l.026.094a6.113 6.113 0 005.83 4.272h8.074c.05-.276.08-.56.08-.85a4.795 4.795 0 00-1.566-3.546 4.792 4.792 0 00-3.248-1.268h-9.408z",
    fill: "url(#MirEngBig_svg__MirEngBig_svg__paint0_linear_28028_71930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.97 9.11l-1.81 6.279h-.311L15.037 9.11a2.484 2.484 0 00-2.387-1.796H8.308v13.664h4.348v-8.074h.31l2.485 8.074h3.106l2.485-8.074h.31v8.074h4.349V7.314h-4.343c-1.107 0-2.08.733-2.387 1.796zm8.594 11.868h4.349V7.314h-4.349v13.664z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MirEngBig_svg__MirEngBig_svg__paint0_linear_28028_71930",
    x1: 33.423,
    y1: 10.146,
    x2: 47.645,
    y2: 10.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  }))));
};

exports.MirEngBig = MirEngBig;
var _default = MirEngBig;
exports.default = _default;